// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileSubHeader_container__1lR9D","subheading":"MobileSubHeader_subheading__3mGLy"};